module.exports = __webpack_public_path__ + "img/17.19b1f64b.png";